declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}

// import login from '../views/login.vue'
// import home from '../views/home/home.vue'
//import main from '../views/main.vue'

// export const locking: any  = {
//     path: '/locking',
//     name: 'locking',
//     meta:{title:'locking',hideInMenu:true},
//     component: () => import('../components/lockscreen/components/locking-page.vue')
// };

// export const otherRouters: Router = {
//     path: '/main',
//     name: 'main',
//     permission: '',
//     meta: { title: 'ManageMenu' },
//     component: main,
//     children: [
//         { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') }
//     ]
// }

// export const routers = [
//     //loginRouter,
//     locking,
//     //...appRouters,
//     //otherRouters
// ];

/********************************定义一个方法将modules中的文件全部导入进来 start********************************/
let homeRouter:any;
const routerList: any[] = [];
function importAll(r: any) {
  r.keys().forEach((key: string) => {

      if(r(key).default.name== 'main'){
        homeRouter = r(key).default;
      }
      // 数组
      if(r(key).default instanceof Array){
        routerList.push(...r(key).default); 
      } else{
        routerList.push(r(key).default);
      }
      
    });
    
  routerList.sort(function(itemA,itemB){
    if(itemA.sort && itemA.sort)
    {
      return itemA.sort-itemB.sort
    }
    else 
    {
      return -1;
    }
  });
}
let allRouterComponents = require.context('../views/', true, /router\.ts$/);

importAll(allRouterComponents);
/********************************定义一个方法将modules中的文件全部导入进来 end********************************/
export const viewRouters = routerList;
export const homePage = homeRouter;

// 用户定义的全部路由
export const routers = [
    ...routerList
];